module.exports = __webpack_public_path__ + "staticVue/img/game_left02.c65fb99b.png";